import { _apiV2_get, _apiV2_post } from "@/app/api2"
import {
  GraffyActiveChatResponse,
  GraffyChatsResponse,
  GraffyNewChatResponse,
  GraffyTokenResponse,
  SummaryEvaluationRequestBody,
  SummaryEvaluationResponse,
  SummaryFetchResponse,
  SummaryRequestBody,
  SummaryRequestResponse,
} from "@/app/types"

// ########## AI API ##########
export async function apiv2_getGraffyToken(): Promise<GraffyTokenResponse> {
  return _apiV2_get("/graffy/token", { key: "graffy_token" })
}

export async function apiv2_getGraffyActiveChat(): Promise<GraffyActiveChatResponse> {
  const responseToken = await apiv2_getGraffyToken()

  const responseChat = await _apiV2_get("/graffy/active-chat", {
    key: "active_graffy_chat",
  })

  return {
    jwt: responseToken.jwt,
    ...responseChat,
  }
}

export async function apiv2_getGraffyChats(): Promise<GraffyChatsResponse> {
  return _apiV2_get("/graffy/chats", { key: "graffy_chats" })
}

export async function apiv2_startGraffyChat(): Promise<GraffyNewChatResponse> {
  const responseToken = await apiv2_getGraffyToken()

  const responseNewChat = await _apiV2_get("/graffy/new-chat", {
    key: "graffy_new_chat",
  })

  return {
    jwt: responseToken.jwt,
    ...responseNewChat,
  }
}

export async function apiv2_requestSummary(
  data: SummaryRequestBody
): Promise<SummaryRequestResponse> {
  return _apiV2_post("/ai/summaries/request", {
    key: "summaryId",
    body: data,
  })
}

export async function apiv2_getSummaryWithId(
  summaryId: string,
  user_key: string
): Promise<SummaryFetchResponse> {
  return _apiV2_get(`/ai/summaries/${summaryId}`, {
    key: `getSummary(${summaryId})`,
    queryParam: { user_key },
  })
}

export async function apiv2_evaluateSummary(
  data: SummaryEvaluationRequestBody
) {
  return _apiV2_post("/ai/summaries/feedbacks", {
    key: "createSummaryEvaluation",
    body: data,
  })
}

export async function apiv2_getSummaryEvaluation(
  summaryId: string,
  user_key: string
): Promise<SummaryEvaluationResponse[]> {
  return _apiV2_get(`/ai/summaries/${summaryId}/feedbacks`, {
    key: "getSummaryEvaluation",
    queryParam: { user_key },
  })
}
